import { FC } from 'react';

export interface IIcon {
  fill?: string;
  stroke?: string;
  size?: number;
}

export const LogoAdminIcon: FC<IIcon> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="229"
      height="32"
      fill="none"
      viewBox="0 0 229 32"
    >
      <g clipPath="url(#clip0_26_11778)">
        <path
          fill="url(#paint0_linear_26_11778)"
          d="M21.463 19.304l-7.93-7.946a1.99 1.99 0 010-2.824l7.93-7.946a1.981 1.981 0 012.818 0l7.93 7.946a1.99 1.99 0 010 2.823l-7.93 7.947c-.73.784-2.035.784-2.818 0z"
        ></path>
        <path
          fill="url(#paint1_linear_26_11778)"
          d="M8.517 31.41l-7.93-7.915a2 2 0 010-2.83l7.93-7.967a1.977 1.977 0 012.817 0l7.93 7.967a2 2 0 010 2.83l-7.93 7.915a1.977 1.977 0 01-2.817 0z"
        ></path>
        <path
          fill="url(#paint2_linear_26_11778)"
          d="M34.41 31.41l-7.93-7.915a2 2 0 010-2.83l7.93-7.967a1.977 1.977 0 012.817 0l7.93 7.967a2 2 0 010 2.83l-7.93 7.915c-.782.787-2.086.787-2.817 0z"
        ></path>
        <path
          fill="#555"
          d="M65.11 23.15l5.079-12.494c.049-.05 0-.152-.098-.152h-4.542c-.049 0-.049 0-.098-.05l-1.563-2.519c-.048-.05 0-.151.098-.151h9.28c.048 0 .097.05.097.1V9.85l-5.177 13.452c0 .05-.049.05-.097.05h-2.833c-.147-.05-.195-.1-.147-.201zM72.518 18.01l.838-2.392c0-.05.044-.05.089-.05h4.145c.044 0 .088.05.088.101v2.392c0 .05-.044.101-.088.101h-5.028c-.044-.05-.088-.101-.044-.152z"
        ></path>
        <path
          fill="#333"
          d="M101.642 23.351v-2.317h-.203c-1.269 0-2.437-.151-3.402-.605-.964-.453-1.726-1.31-2.284-2.216-.559-.907-.813-1.915-.813-2.973 0-1.058.254-2.015.762-2.872.508-.856 1.218-1.511 2.132-2.015.914-.504 2.031-.705 3.3-.705h.559V7.784h2.893v1.864h.56c1.268 0 2.334.252 3.299.705.914.504 1.625 1.159 2.133 2.015.507.857.761 1.814.761 2.872 0 1.109-.254 2.066-.812 2.973-.558.906-1.371 1.763-2.335 2.216-.965.454-2.031.605-3.351.605h-.305v2.317h-2.894zm0-11.234h-.406c-1.015 0-1.828.302-2.387.856-.558.554-.863 1.31-.863 2.267 0 1.008.305 1.763.914 2.368.61.605 1.524.907 2.641.907h.152v-6.399h-.051zm2.894 6.297h.152c1.117 0 1.98-.302 2.64-.856.61-.555.965-1.36.965-2.368 0-.907-.304-1.663-.863-2.267-.609-.555-1.371-.857-2.386-.857h-.508v6.348zM93.214 15.492c0 2.469-.535 4.534-1.75 5.844-1.167 1.31-2.966 2.015-5.154 2.015-2.189 0-3.94-.655-5.106-2.015-1.167-1.31-1.8-3.375-1.8-5.894 0-2.52.633-4.383 1.849-5.693 1.215-1.31 2.868-1.965 5.105-1.965 2.237 0 3.89.655 5.057 1.965 1.118 1.31 1.8 3.224 1.8 5.743zm-10.6 0c0 1.663.292 3.174.924 4.03.632.857 1.556 1.36 2.772 1.36 2.43 0 3.695-1.964 3.695-5.34 0-3.375-1.216-5.34-3.647-5.34-1.215 0-2.14.605-2.771 1.461-.681.857-.973 2.116-.973 3.829z"
        ></path>
        <path
          fill="#555"
          d="M63.87 12.57c0 1.662-.53 2.922-1.642 3.829-1.111.856-2.646 1.31-4.657 1.31h-1.482v5.642h-3.44V7.784h5.187c1.958 0 3.44.403 4.498 1.209 1.006.806 1.535 2.015 1.535 3.577zm-7.78 2.469h1.11c1.059 0 1.853-.202 2.382-.605.53-.403.794-.957.794-1.713 0-.756-.212-1.31-.635-1.713-.423-.352-1.111-.554-2.064-.554h-1.588v4.585z"
        ></path>
        <path
          fill="#333"
          d="M113.112 7.784h2.721v7.432l-.047 2.009-.094 2.26h.047l6.614-11.651h3.659v15.517h-2.721V15.82c0-1.005.047-2.461.188-4.42h-.094l-6.661 11.902h-3.659V7.784h.047zM134.609 10.454c-1.186 0-2.076.453-2.718 1.36-.643.907-.989 2.167-.989 3.779 0 3.325 1.235 5.39 3.707 5.39 1.038 0 2.274-.251 3.757-.806v2.419c-1.187.503-2.571.755-4.054.755-2.125 0-3.757-.655-4.893-1.964-1.137-1.31-1.681-3.376-1.681-5.845 0-1.561.297-2.922.841-4.08.544-1.16 1.334-2.066 2.422-2.721 1.037-.605 2.273-.957 3.658-.957 1.432 0 2.866.352 4.3 1.058l-.989 2.57c-.543-.253-1.087-.505-1.681-.706-.593-.202-1.137-.252-1.68-.252z"
        ></path>
      </g>
      <path
        fill="#CED4DA"
        d="M156.472 23.189l-1.131-3.695h-5.662l-1.131 3.695H145l5.481-15.598h4.032l5.507 15.598h-3.548zm-1.916-6.466l-1.122-3.616a33.428 33.428 0 00-.285-.933c-.121-.38-.233-.768-.354-1.156-.121-.398-.207-.734-.285-1.028-.069.294-.173.648-.294 1.08-.12.43-.241.837-.353 1.216-.113.38-.199.657-.242.82l-1.114 3.617h4.049zM174.893 7.651v12.793h2.072v5.542h-3.177V23.18h-9.737v2.806h-3.176v-5.542h1.199a37.14 37.14 0 001.166-2.564c.38-.897.725-1.864 1.053-2.9.328-1.036.621-2.158.88-3.367a43.85 43.85 0 00.656-3.962h9.064zm-3.28 2.745h-3.159a33.594 33.594 0 01-.432 2.4 39.515 39.515 0 01-.656 2.598 43.5 43.5 0 01-.837 2.607 35.705 35.705 0 01-.985 2.443h6.069V10.388v.008zM185.519 23.189L181.781 11h-.095c.018.294.035.726.069 1.313.035.586.061 1.208.087 1.864.026.656.043 1.252.043 1.787v7.225h-2.944V7.65h4.489l3.677 11.878h.061L191.07 7.65h4.488V23.19h-3.073v-7.355c0-.492 0-1.053.026-1.691.017-.64.043-1.244.069-1.822.026-.578.052-1.01.061-1.303h-.095l-4.006 12.17h-3.021zM198.856 7.651h2.961v7.501c0 .372 0 .777-.018 1.226-.008.45-.026.88-.043 1.312-.017.432-.034.803-.052 1.122-.017.32-.025.536-.043.64h.061l7.173-11.8h3.945v15.537h-2.935V15.73c0-.397 0-.829.026-1.295.017-.466.034-.924.06-1.364.026-.44.052-.82.069-1.14.018-.319.035-.534.043-.647h-.086l-7.208 11.904h-3.962V7.65h.009zM228.887 23.189h-3.28v-6.707h-6.155v6.707h-3.297V7.65h3.297v6.086h6.155V7.65h3.28V23.19z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_26_11778"
          x1="22.889"
          x2="22.889"
          y1="19.889"
          y2="0.013"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF8745"></stop>
          <stop offset="1" stopColor="#D13700"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_26_11778"
          x1="9.931"
          x2="9.931"
          y1="32.106"
          y2="12.177"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4EB7E5"></stop>
          <stop offset="1" stopColor="#328BCB"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_26_11778"
          x1="35.8"
          x2="35.8"
          y1="32.022"
          y2="12.094"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9BDA32"></stop>
          <stop offset="1" stopColor="#6EA70E"></stop>
        </linearGradient>
        <clipPath id="clip0_26_11778">
          <path fill="#fff" d="M0 0H145V32H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export const GroupsIcon: FC<IIcon> = ({ stroke = '#101828' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13M16 3.13C16.8604 3.3503 17.623 3.8507 18.1676 4.55231C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89317 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UsersIcon: FC<IIcon> = ({ stroke = '#101828' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RocketIcon: FC<IIcon> = ({ stroke = '#101828' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.959 5.96a14.922 14.922 0 01-5.84 2.58m0 0a15.53 15.53 0 01-.311.06 15.091 15.091 0 01-2.448-2.448 14.9 14.9 0 01.059-.312m2.581-5.84a6 6 0 00-7.381 5.84h4.8m2.581-5.84a14.928 14.928 0 00-2.581 5.84m-2.239 2.39a4.493 4.493 0 00-1.757 4.306 4.493 4.493 0 004.306-1.758M16.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
      ></path>
    </svg>
  );
};

export const SettingsIcon: FC<IIcon> = ({ stroke = '#101828' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M4.5 12a7.5 7.5 0 0015 0m-15 0a7.5 7.5 0 0115 0m-15 0H3m16.5 0H21m-1.5 0H12L7.5 4.205M3.543 15.077l1.41-.513m14.095-5.13l1.41-.513M5.106 17.785l1.15-.964m11.49-9.642l1.149-.964M7.501 19.795l.75-1.3L12.002 12m3.749-6.495l.75-1.3m-6.063 16.658l.26-1.477m2.605-14.772l.26-1.477m0 17.726l-.26-1.477M10.698 4.614l-.26-1.477M16.5 19.794l-.75-1.3m3.144-.71l-1.149-.963M6.256 7.178l-1.15-.964m15.352 8.864l-1.41-.513M4.954 9.435l-1.41-.514"
      ></path>
    </svg>
  );
};

export const TimezonesIcon: FC<IIcon> = ({ stroke = '#101828' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-timezone"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M20.884 10.554a9 9 0 1 0 -10.337 10.328" />
      <path d="M3.6 9h16.8" />
      <path d="M3.6 15h6.9" />
      <path d="M11.5 3a17 17 0 0 0 -1.502 14.954" />
      <path d="M12.5 3a17 17 0 0 1 2.52 7.603" />
      <path d="M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
      <path d="M18 16.5v1.5l.5 .5" />
    </svg>
  );
};

export const CustomisationIcon: FC<IIcon> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      className="icon icon-tabler icon-tabler-settings-automation"
      viewBox="0 0 24 24"
    >
      <path stroke="none" d="M0 0h24v24H0z"></path>
      <path d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37 1 .608 2.296.07 2.572-1.065z"></path>
      <path d="M10 9v6l5-3z"></path>
    </svg>
  );
};

export const inviteUserIcon: FC<IIcon> = ({ stroke = '#101828' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 1112.75 0v.109A12.318 12.318 0 0110.374 21C8.043 21 5.862 20.355 4 19.234v.001z"
      ></path>
    </svg>
  );
};

export const FilialsIcon: FC<IIcon> = ({ stroke = '#101828' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.25 21H21.75M3.75 3V21M14.25 3V21M20.25 7.5V21M6.75 6.75H7.5M6.75 9.75H7.5M6.75 12.75H7.5M10.5 6.75H11.25M10.5 9.75H11.25M10.5 12.75H11.25M6.75 21V17.625C6.75 17.004 7.254 16.5 7.875 16.5H10.125C10.746 16.5 11.25 17.004 11.25 17.625V21M3 3H15M14.25 7.5H21M17.25 11.25H17.258V11.258H17.25V11.25ZM17.25 14.25H17.258V14.258H17.25V14.25ZM17.25 17.25H17.258V17.258H17.25V17.25Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WarningCircleIcon: FC<IIcon> = ({ stroke = '#101828' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DeleteIcon: FC<IIcon> = ({ stroke = '#101828' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 6H5M5 6H21M5 6V20C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H17C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20V6H5ZM8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M10 11V17M14 11V17"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SidebarRightIcon: FC<IIcon> = ({ stroke = '#98A2B3' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 3V21M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CloseIcon: FC<IIcon> = ({ fill = '#98A2B3' }) => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.27984 2.72051C2.65296 2.34739 3.2577 2.34739 3.63062 2.72051L8.13333 7.22322L12.636 2.72051C13.0092 2.34739 13.6139 2.34739 13.9868 2.72051C14.3599 3.09363 14.3599 3.69838 13.9868 4.0713L9.48412 8.57401L13.9868 13.0767C14.3599 13.4498 14.3599 14.0546 13.9868 14.4275C13.6137 14.8006 13.009 14.8004 12.636 14.4275L8.13333 9.92479L3.63062 14.4275C3.25751 14.8004 2.65276 14.8004 2.27984 14.4275C1.90672 14.0544 1.90672 13.4496 2.27984 13.0767L6.78255 8.57401L2.27984 4.0713C1.90672 3.69818 1.90672 3.09343 2.27984 2.72051Z"
        fill={fill}
      />
    </svg>
  );
};

export const PlusIcon: FC<IIcon> = ({ stroke = '#667085' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 5V19M5 12H19"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SearchIcon: FC<IIcon> = ({ stroke = '#98A2B3' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DriveIcon: FC<Partial<{ stroke: string }>> = ({ stroke = '#101828' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22 12H2M22 12V18C22 18.5304 21.7893 19.0391 21.4142 19.4142C21.0391 19.7893 20.5304 20 20 20H4C3.46957 20 2.96086 19.7893 2.58579 19.4142C2.21071 19.0391 2 18.5304 2 18V12M22 12L18.55 5.11C18.3844 4.77679 18.1292 4.49637 17.813 4.30028C17.4967 4.10419 17.1321 4.0002 16.76 4H7.24C6.86792 4.0002 6.50326 4.10419 6.18704 4.30028C5.87083 4.49637 5.61558 4.77679 5.45 5.11L2 12M6 16H6.01M10 16H10.01"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChecklistIcon: FC<Partial<{ stroke: string }>> = ({ stroke = '#101828' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.615 20H7C6.46957 20 5.96086 19.7893 5.58579 19.4142C5.21071 19.0391 5 18.5304 5 18V6C5 5.46957 5.21071 4.96086 5.58579 4.58579C5.96086 4.21071 6.46957 4 7 4H15C15.5304 4 16.0391 4.21071 16.4142 4.58579C16.7893 4.96086 17 5.46957 17 6V14M14 19L16 21L20 17M9 8H13M9 12H11"
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DrawIcon: FC<Partial<{ stroke: string }>> = ({ stroke = '#101828' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M14.25 6.087c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.036-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959a.641.641 0 01-.657.643c-1.391-.04-2.78-.14-4.163-.3a48.44 48.44 0 01.315 4.907.656.656 0 01-.658.663c-.355 0-.676-.186-.959-.401a1.647 1.647 0 00-1.003-.349c-1.036 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401.31 0 .555.26.532.57a48.042 48.042 0 01-.642 5.056c1.518.19 3.058.309 4.616.354a.64.64 0 00.657-.643c0-.355-.186-.676-.401-.959a1.647 1.647 0 01-.349-1.003c0-1.035 1.008-1.875 2.25-1.875 1.243 0 2.25.84 2.25 1.875 0 .369-.128.713-.349 1.003-.215.283-.4.604-.4.959 0 .333.277.599.61.58a48.086 48.086 0 005.427-.63c.272-1.562.466-3.136.582-4.717a.533.533 0 00-.533-.57c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.035 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.37 0 .713.128 1.003.349.283.215.604.401.96.401a.655.655 0 00.658-.663 48.42 48.42 0 00-.37-5.36 48.14 48.14 0 01-5.766.689.578.578 0 01-.61-.579z"
    ></path>
  </svg>
);

export const ContactsIcon: FC<Partial<{ stroke: string }>> = ({ stroke = '#101828' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2m1-17.87a4 4 0 010 7.75M21 21v-2a4 4 0 00-3-3.85M5 7a4 4 0 108 0 4 4 0 00-8 0z"
    ></path>
  </svg>
);

export const ProjectsIcon: FC<Partial<{ stroke: string }>> = ({ stroke = '#98A2B3' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <g clipPath="url(#clip0_27_12)">
      <path
        stroke={stroke}
        strokeWidth="1.5"
        d="M3.25.9h17.5c1.535 0 2.75 1.199 2.75 2.642v16.916c0 1.443-1.215 2.642-2.75 2.642H3.25C1.715 23.1.5 21.901.5 20.458V3.542C.5 2.099 1.715.9 3.25.9z"
      ></path>
      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M6.69 12l3.792 3.667 7.587-7.334"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_27_12">
        <path fill="#fff" d="M0 0H24V24H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const CalendarIcon: FC<Partial<{ color: string }>> = ({ color = '#98A2B3' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
  >
    <path
      d="M16 2V6M8 2V6M3 10H21M5 4H19C20.1046 4 21 4.89543 21 6V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V6C3 4.89543 3.89543 4 5 4Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarExtraIcon: FC<Partial<{ stroke: string }>> = ({ stroke = '#667085' }) => (
  <svg width="24" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.75 1V3.25M15.25 1V3.25M1 16.75V5.5C1 4.90326 1.23705 4.33097 1.65901 3.90901C2.08097 3.48705 2.65326 3.25 3.25 3.25H16.75C17.3467 3.25 17.919 3.48705 18.341 3.90901C18.7629 4.33097 19 4.90326 19 5.5V16.75M1 16.75C1 17.3467 1.23705 17.919 1.65901 18.341C2.08097 18.7629 2.65326 19 3.25 19H16.75C17.3467 19 17.919 18.7629 18.341 18.341C18.7629 17.919 19 17.3467 19 16.75M1 16.75V9.25C1 8.65326 1.23705 8.08097 1.65901 7.65901C2.08097 7.23705 2.65326 7 3.25 7H16.75C17.3467 7 17.919 7.23705 18.341 7.65901C18.7629 8.08097 19 8.65326 19 9.25V16.75M10 10.75H10.008V10.758H10V10.75ZM10 13H10.008V13.008H10V13ZM10 15.25H10.008V15.258H10V15.25ZM7.75 13H7.758V13.008H7.75V13ZM7.75 15.25H7.758V15.258H7.75V15.25ZM5.5 13H5.508V13.008H5.5V13ZM5.5 15.25H5.508V15.258H5.5V15.25ZM12.25 10.75H12.258V10.758H12.25V10.75ZM12.25 13H12.258V13.008H12.25V13ZM12.25 15.25H12.258V15.258H12.25V15.25ZM14.5 10.75H14.508V10.758H14.5V10.75ZM14.5 13H14.508V13.008H14.5V13Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const NotificationNavIcon: FC<Partial<{ stroke: string }>> = ({ stroke = '#101828' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <g
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        clipPath="url(#clip0_5599_36798)"
      >
        <path d="M10 6H7a2 2 0 00-2 2v9a2 2 0 002 2h9a2 2 0 002-2v-3M14 7a3 3 0 106 0 3 3 0 00-6 0z"></path>
      </g>
      <defs>
        <clipPath id="clip0_5599_36798">
          <path fill="#fff" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
export const ArrowLeftIcon: FC<Partial<{ color: string }>> = ({ color = '#667085' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
  >
    <path
      d="M19 12H5M5 12L12 19M5 12L12 5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LockIcon: FC<Partial<{ color: string }>> = ({ color = '#98A2B3' }) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
  >
    <path
      d="M7 11.5V7.5C7 6.17392 7.52678 4.90215 8.46447 3.96447C9.40215 3.02678 10.6739 2.5 12 2.5C13.3261 2.5 14.5979 3.02678 15.5355 3.96447C16.4732 4.90215 17 6.17392 17 7.5V11.5M5 11.5H19C20.1046 11.5 21 12.3954 21 13.5V20.5C21 21.6046 20.1046 22.5 19 22.5H5C3.89543 22.5 3 21.6046 3 20.5V13.5C3 12.3954 3.89543 11.5 5 11.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const RefreshIcon: FC<Partial<{ color: string }>> = ({ color = '#667085' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
  >
    <path
      d="M1 4.00008V10.0001M1 10.0001H7M1 10.0001L5.64 5.64008C6.71475 4.56479 8.04437 3.77928 9.50481 3.35685C10.9652 2.93442 12.5089 2.88883 13.9917 3.22433C15.4745 3.55984 16.8482 4.26551 17.9845 5.27549C19.1209 6.28548 19.9828 7.56686 20.49 9.00008M23 20.0001V14.0001M23 14.0001H17M23 14.0001L18.36 18.3601C17.2853 19.4354 15.9556 20.2209 14.4952 20.6433C13.0348 21.0657 11.4911 21.1113 10.0083 20.7758C8.52547 20.4403 7.1518 19.7346 6.01547 18.7247C4.87913 17.7147 4.01717 16.4333 3.51 15.0001"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EditIcon: FC<IIcon> = ({ stroke = '#667085' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 4.00023H4C3.46957 4.00023 2.96086 4.21094 2.58579 4.58601C2.21071 4.96109 2 5.46979 2 6.00023V20.0002C2 20.5307 2.21071 21.0394 2.58579 21.4144C2.96086 21.7895 3.46957 22.0002 4 22.0002H18C18.5304 22.0002 19.0391 21.7895 19.4142 21.4144C19.7893 21.0394 20 20.5307 20 20.0002V13.0002M18.5 2.50023C18.8978 2.1024 19.4374 1.87891 20 1.87891C20.5626 1.87891 21.1022 2.1024 21.5 2.50023C21.8978 2.89805 22.1213 3.43762 22.1213 4.00023C22.1213 4.56284 21.8978 5.1024 21.5 5.50023L12 15.0002L8 16.0002L9 12.0002L18.5 2.50023Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MailIcon: FC<IIcon> = ({ stroke = '#667085' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6M22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6M22 6L12 13L2 6"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SendIcon: FC<IIcon> = ({ stroke = '#667085' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.99955 12L3.26855 3.12598C9.80136 5.02565 15.9619 8.02677 21.4846 12C15.9623 15.9738 9.80213 18.9755 3.26955 20.876L5.99955 12ZM5.99955 12H13.4996"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ServerIcon: FC<IIcon> = ({ stroke = '#667085' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 6H6.01M6 18H6.01M4 2H20C21.1046 2 22 2.89543 22 4V8C22 9.10457 21.1046 10 20 10H4C2.89543 10 2 9.10457 2 8V4C2 2.89543 2.89543 2 4 2ZM4 14H20C21.1046 14 22 14.8954 22 16V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V16C2 14.8954 2.89543 14 4 14Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NotesIcon: FC<IIcon> = ({ stroke = '#667085' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H8M9 2H15C15.5523 2 16 2.44772 16 3V5C16 5.55228 15.5523 6 15 6H9C8.44772 6 8 5.55228 8 5V3C8 2.44772 8.44772 2 9 2Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DatabaseIcon: FC<IIcon> = ({ stroke = '#667085' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 5C21 6.65685 16.9706 8 12 8C7.02944 8 3 6.65685 3 5M21 5C21 3.34315 16.9706 2 12 2C7.02944 2 3 3.34315 3 5M21 5V19C21 20.66 17 22 12 22C7 22 3 20.66 3 19V5M21 12C21 13.66 17 15 12 15C7 15 3 13.66 3 12"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const InfoIcon: FC<IIcon> = ({ stroke = '#C01048' }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM9.3 5.30001C9.3 6.01798 8.71797 6.60001 8 6.60001C7.28203 6.60001 6.7 6.01798 6.7 5.30001C6.7 4.58204 7.28203 4.00001 8 4.00001C8.71797 4.00001 9.3 4.58204 9.3 5.30001ZM7.97594 12C7.53635 12 7.18 11.6437 7.18 11.2041V8.29595C7.18 7.85636 7.53635 7.50001 7.97594 7.50001C8.41553 7.50001 8.77188 7.85636 8.77188 8.29595V11.2041C8.77188 11.6437 8.41553 12 7.97594 12Z"
        fill={stroke}
      />
    </svg>
  );
};

export const CircleCloseIcon: FC<IIcon> = ({ fill = '#D0D5DD' }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM4.64124 4.6413C4.93413 4.34841 5.40901 4.34841 5.7019 4.6413L8 6.9394L10.2981 4.6413C10.591 4.34841 11.0659 4.34841 11.3588 4.6413C11.6516 4.93419 11.6516 5.40907 11.3588 5.70196L9.06066 8.00006L11.3588 10.2982C11.6516 10.591 11.6516 11.0659 11.3588 11.3588C11.0659 11.6517 10.591 11.6517 10.2981 11.3588L8 9.06072L5.7019 11.3588C5.40901 11.6517 4.93413 11.6517 4.64124 11.3588C4.34835 11.0659 4.34835 10.591 4.64124 10.2982L6.93934 8.00006L4.64124 5.70196C4.34835 5.40907 4.34835 4.93419 4.64124 4.6413Z"
        fill={fill}
      />
    </svg>
  );
};

export const SaveIcon: FC<IIcon> = ({ stroke = '#667085' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 21V13H7V21M7 3V8H15M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16L21 8V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MonitorIcon: FC<IIcon> = ({ stroke = '#667085' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 21H16M12 17V21M4 3H20C21.1046 3 22 3.89543 22 5V15C22 16.1046 21.1046 17 20 17H4C2.89543 17 2 16.1046 2 15V5C2 3.89543 2.89543 3 4 3Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LoginHistoryIcon: FC<IIcon> = ({ stroke = '#667085' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23 4.00001V10M23 10H17M23 10L18.37 5.64001C16.9906 4.25975 15.2 3.3652 13.268 3.09116C11.3359 2.81711 9.36717 3.17843 7.65836 4.12065C5.94954 5.06288 4.59325 6.53496 3.79386 8.31508C2.99448 10.0952 2.79531 12.0869 3.22637 13.9901C3.65743 15.8932 4.69536 17.6047 6.18376 18.8667C7.67216 20.1286 9.53038 20.8726 11.4784 20.9866C13.4265 21.1006 15.3588 20.5783 16.9842 19.4985C18.6096 18.4187 19.84 16.8399 20.49 15"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FileIcon: FC<IIcon> = ({ stroke = '#667085' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9M13 2L20 9M13 2V9H20"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LinkIcon: FC<IIcon> = ({ stroke = '#667085' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99996 13C10.4294 13.5741 10.9773 14.0492 11.6065 14.3929C12.2357 14.7367 12.9315 14.9411 13.6466 14.9923C14.3617 15.0435 15.0795 14.9404 15.7513 14.6898C16.4231 14.4392 17.0331 14.0471 17.54 13.54L20.54 10.54C21.4507 9.59699 21.9547 8.33397 21.9433 7.02299C21.9319 5.71201 21.4061 4.45794 20.479 3.5309C19.552 2.60386 18.2979 2.07802 16.987 2.06663C15.676 2.05523 14.413 2.55921 13.47 3.47L11.75 5.18M14 11C13.5705 10.4259 13.0226 9.95081 12.3934 9.60706C11.7642 9.2633 11.0684 9.05888 10.3533 9.00766C9.63816 8.95645 8.92037 9.05963 8.24861 9.31021C7.57685 9.5608 6.96684 9.95293 6.45996 10.46L3.45996 13.46C2.54917 14.403 2.04519 15.666 2.05659 16.977C2.06798 18.288 2.59382 19.542 3.52086 20.4691C4.4479 21.3961 5.70197 21.922 7.01295 21.9334C8.32393 21.9448 9.58694 21.4408 10.53 20.53L12.24 18.82"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TrashIcon: FC<IIcon> = ({ stroke = '#667085' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 6H5M5 6H21M5 6V20C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H17C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20V6H5ZM8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronsLeft: FC<IIcon> = ({ stroke = '#667085' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 17L6 12L11 7M18 17L13 12L18 7"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CompanyPlaceholder: FC<IIcon> = ({ size, stroke = '#667085' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z"
      ></path>
    </svg>
  );
};

export const RolesPlaceholder: FC<IIcon> = ({ size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#667085"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2m22 0v-2a4 4 0 00-3-3.87m-4-12a4 4 0 010 7.75M13 7a4 4 0 11-8 0 4 4 0 018 0z"
      ></path>
    </svg>
  );
};
export const ShieldIcon: FC<Partial<{ stroke: string }>> = ({ stroke = '#101828' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 12.7508L11.25 15.0008L15 9.75084M12 2.71484C9.73574 4.86508 6.72026 6.04442 3.598 6.00084C3.20084 7.21082 2.99898 8.47635 3 9.74984C3 15.3418 6.824 20.0398 12 21.3728C17.176 20.0408 21 15.3428 21 9.75084C21 8.44084 20.79 7.17984 20.402 5.99984H20.25C17.054 5.99984 14.15 4.75184 12 2.71484Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ActivityIcon: FC<Partial<{ stroke: string }>> = ({ stroke = '#667085' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.042 21.6723L13.684 16.6003M13.684 16.6003L11.174 18.8253L11.743 9.35526L16.97 17.2723L13.684 16.6003ZM6.166 16.3333C5.20672 15.3739 4.49886 14.1927 4.1051 12.8944C3.71135 11.5961 3.64386 10.2207 3.90861 8.89006C4.17337 7.55943 4.76219 6.31464 5.62293 5.26593C6.48367 4.21722 7.58976 3.39698 8.84322 2.87785C10.0967 2.35872 11.4588 2.15672 12.809 2.28976C14.1592 2.4228 15.4557 2.88677 16.5837 3.64056C17.7118 4.39435 18.6365 5.41471 19.276 6.61124C19.9155 7.80777 20.25 9.14355 20.25 10.5003M8.288 14.2123C7.67742 13.6018 7.22684 12.8502 6.97615 12.0239C6.72547 11.1977 6.68243 10.3224 6.85084 9.47559C7.01926 8.62876 7.39393 7.83654 7.94167 7.16911C8.48941 6.50168 9.1933 5.97964 9.991 5.64924C10.7887 5.31884 11.6556 5.19028 12.5148 5.27495C13.3741 5.35961 14.1992 5.65489 14.917 6.13463C15.6349 6.61436 16.2234 7.26374 16.6303 8.02524C17.0373 8.78674 17.2501 9.63685 17.25 10.5003"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GearIcon: FC<Partial<{ stroke: string }>> = ({ stroke = '#667085 ' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.59372 3.94C9.68372 3.398 10.1537 3 10.7037 3H13.2967C13.8467 3 14.3167 3.398 14.4067 3.94L14.6197 5.221C14.6827 5.595 14.9327 5.907 15.2647 6.091C15.3387 6.131 15.4117 6.174 15.4847 6.218C15.8087 6.414 16.2047 6.475 16.5597 6.342L17.7767 5.886C18.0261 5.79221 18.3007 5.78998 18.5516 5.87971C18.8025 5.96945 19.0134 6.14531 19.1467 6.376L20.4427 8.623C20.5758 8.8537 20.6227 9.12413 20.5751 9.38617C20.5275 9.6482 20.3884 9.88485 20.1827 10.054L19.1797 10.881C18.8867 11.121 18.7417 11.494 18.7487 11.873C18.7503 11.958 18.7503 12.043 18.7487 12.128C18.7417 12.506 18.8867 12.878 19.1787 13.118L20.1837 13.946C20.6077 14.296 20.7177 14.9 20.4437 15.376L19.1457 17.623C19.0126 17.8536 18.8019 18.0296 18.5512 18.1195C18.3005 18.2094 18.0261 18.2074 17.7767 18.114L16.5597 17.658C16.2047 17.525 15.8097 17.586 15.4837 17.782C15.4112 17.8261 15.3379 17.8688 15.2637 17.91C14.9327 18.093 14.6827 18.405 14.6197 18.779L14.4067 20.059C14.3167 20.602 13.8467 21 13.2967 21H10.7027C10.1527 21 9.68272 20.602 9.59272 20.06L9.37972 18.779C9.31772 18.405 9.06772 18.093 8.73572 17.909C8.66157 17.8681 8.58822 17.8258 8.51572 17.782C8.19072 17.586 7.79572 17.525 7.43972 17.658L6.22272 18.114C5.97345 18.2075 5.69908 18.2096 5.44842 18.1199C5.19775 18.0302 4.98703 17.8545 4.85372 17.624L3.55672 15.377C3.42366 15.1463 3.37676 14.8759 3.42437 14.6138C3.47198 14.3518 3.61101 14.1152 3.81672 13.946L4.82072 13.119C5.11272 12.879 5.25772 12.506 5.25072 12.127C5.24915 12.042 5.24915 11.957 5.25072 11.872C5.25772 11.494 5.11272 11.122 4.82072 10.882L3.81672 10.054C3.61126 9.88489 3.47239 9.64843 3.42479 9.38662C3.37719 9.12481 3.42393 8.8546 3.55672 8.624L4.85372 6.377C4.9869 6.14614 5.19773 5.97006 5.44863 5.88014C5.69953 5.79021 5.97421 5.79229 6.22372 5.886L7.43972 6.342C7.79572 6.475 8.19072 6.414 8.51572 6.218C8.58772 6.174 8.66172 6.131 8.73572 6.09C9.06772 5.907 9.31772 5.595 9.37972 5.221L9.59372 3.94Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LoginAsIcon: FC<IIcon> = ({ stroke = '#667085' }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.125 7.5V4.375C13.125 3.87772 12.9275 3.40081 12.5758 3.04917C12.2242 2.69754 11.7473 2.5 11.25 2.5H6.25C5.75272 2.5 5.27581 2.69754 4.92417 3.04917C4.57254 3.40081 4.375 3.87772 4.375 4.375V15.625C4.375 16.1223 4.57254 16.5992 4.92417 16.9508C5.27581 17.3025 5.75272 17.5 6.25 17.5H11.25C11.7473 17.5 12.2242 17.3025 12.5758 16.9508C12.9275 16.5992 13.125 16.1223 13.125 15.625V12.5M15.625 12.5L18.125 10M18.125 10L15.625 7.5M18.125 10H7.5"
        stroke={stroke}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BlockIcon: FC<IIcon> = ({ stroke = '#667085' }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.75 8.75V5.625C13.75 4.63044 13.3549 3.67661 12.6516 2.97335C11.9484 2.27009 10.9946 1.875 10 1.875C9.00544 1.875 8.05161 2.27009 7.34835 2.97335C6.64509 3.67661 6.25 4.63044 6.25 5.625V8.75M5.625 18.125H14.375C14.8723 18.125 15.3492 17.9275 15.7008 17.5758C16.0525 17.2242 16.25 16.7473 16.25 16.25V10.625C16.25 10.1277 16.0525 9.65081 15.7008 9.29917C15.3492 8.94754 14.8723 8.75 14.375 8.75H5.625C5.12772 8.75 4.65081 8.94754 4.29917 9.29917C3.94754 9.65081 3.75 10.1277 3.75 10.625V16.25C3.75 16.7473 3.94754 17.2242 4.29917 17.5758C4.65081 17.9275 5.12772 18.125 5.625 18.125Z"
        stroke={stroke}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LockOpenIcon: FC<IIcon> = ({ stroke = '#667085' }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.25 8.75V5.625C11.25 4.63044 11.6451 3.67661 12.3483 2.97335C13.0516 2.27009 14.0054 1.875 15 1.875C15.9946 1.875 16.9484 2.27009 17.6516 2.97335C18.3549 3.67661 18.75 4.63044 18.75 5.625V8.75M3.125 18.125H11.875C12.3723 18.125 12.8492 17.9275 13.2008 17.5758C13.5525 17.2242 13.75 16.7473 13.75 16.25V10.625C13.75 10.1277 13.5525 9.65081 13.2008 9.29917C12.8492 8.94754 12.3723 8.75 11.875 8.75H3.125C2.62772 8.75 2.15081 8.94754 1.79917 9.29917C1.44754 9.65081 1.25 10.1277 1.25 10.625V16.25C1.25 16.7473 1.44754 17.2242 1.79917 17.5758C2.15081 17.9275 2.62772 18.125 3.125 18.125Z"
        stroke={stroke}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EditProfileIcon: FC<IIcon> = ({ stroke = '#667085', size = '20' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0517 3.73937L15.4575 2.33271C15.7506 2.03964 16.148 1.875 16.5625 1.875C16.977 1.875 17.3744 2.03964 17.6675 2.33271C17.9606 2.62577 18.1252 3.02325 18.1252 3.43771C18.1252 3.85216 17.9606 4.24964 17.6675 4.54271L8.81833 13.3919C8.37777 13.8322 7.83447 14.1558 7.2375 14.3335L5 15.0002L5.66667 12.7627C5.8444 12.1657 6.16803 11.6224 6.60833 11.1819L14.0517 3.73937ZM14.0517 3.73937L16.25 5.93771M15 11.6669V15.6252C15 16.1225 14.8025 16.5994 14.4508 16.951C14.0992 17.3027 13.6223 17.5002 13.125 17.5002H4.375C3.87772 17.5002 3.40081 17.3027 3.04917 16.951C2.69754 16.5994 2.5 16.1225 2.5 15.6252V6.87521C2.5 6.37793 2.69754 5.90101 3.04917 5.54938C3.40081 5.19775 3.87772 5.00021 4.375 5.00021H8.33333"
        stroke={stroke}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ConfirmMailIcon: FC<IIcon> = ({ stroke = '#667085' }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.0001 7.50043V10.6254M2.2476 13.4388C1.52593 14.6888 2.42843 16.2504 3.87093 16.2504H16.1293C17.5709 16.2504 18.4734 14.6888 17.7526 13.4388L11.6243 2.81543C10.9026 1.56543 9.09759 1.56543 8.37593 2.81543L2.2476 13.4388ZM10.0001 13.1254H10.0059V13.1321H10.0001V13.1254Z"
        stroke={stroke}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AddRoleIcon: FC<IIcon> = ({ stroke = '#667085' }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8333 6.25V8.75M15.8333 8.75V11.25M15.8333 8.75H18.3333M15.8333 8.75H13.3333M11.4583 5.3125C11.4583 5.68184 11.3855 6.04757 11.2442 6.3888C11.1028 6.73003 10.8957 7.04007 10.6345 7.30124C10.3733 7.5624 10.0633 7.76957 9.72205 7.91091C9.38082 8.05225 9.01509 8.125 8.64575 8.125C8.27641 8.125 7.91068 8.05225 7.56945 7.91091C7.22823 7.76957 6.91818 7.5624 6.65701 7.30124C6.39585 7.04007 6.18868 6.73003 6.04734 6.3888C5.906 6.04757 5.83325 5.68184 5.83325 5.3125C5.83325 4.56658 6.12957 3.85121 6.65701 3.32376C7.18446 2.79632 7.89983 2.5 8.64575 2.5C9.39167 2.5 10.107 2.79632 10.6345 3.32376C11.1619 3.85121 11.4583 4.56658 11.4583 5.3125ZM3.33325 16.0292V15.9375C3.33325 14.5285 3.89296 13.1773 4.88925 12.181C5.88553 11.1847 7.23679 10.625 8.64575 10.625C10.0547 10.625 11.406 11.1847 12.4023 12.181C13.3985 13.1773 13.9583 14.5285 13.9583 15.9375V16.0283C12.3545 16.9942 10.5171 17.5032 8.64492 17.5C6.70242 17.5 4.88492 16.9625 3.33325 16.0283V16.0292Z"
        stroke={stroke}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WriteMailIcon: FC<IIcon> = ({ stroke = '#667085' }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.125 5.625V14.375C18.125 14.8723 17.9275 15.3492 17.5758 15.7008C17.2242 16.0525 16.7473 16.25 16.25 16.25H3.75C3.25272 16.25 2.77581 16.0525 2.42417 15.7008C2.07254 15.3492 1.875 14.8723 1.875 14.375V5.625M18.125 5.625C18.125 5.12772 17.9275 4.65081 17.5758 4.29917C17.2242 3.94754 16.7473 3.75 16.25 3.75H3.75C3.25272 3.75 2.77581 3.94754 2.42417 4.29917C2.07254 4.65081 1.875 5.12772 1.875 5.625M18.125 5.625V5.8275C18.125 6.14762 18.0431 6.46242 17.887 6.74191C17.7309 7.0214 17.5059 7.25628 17.2333 7.42417L10.9833 11.27C10.6877 11.4521 10.3472 11.5485 10 11.5485C9.65275 11.5485 9.31233 11.4521 9.01667 11.27L2.76667 7.425C2.4941 7.25711 2.26906 7.02224 2.11297 6.74275C1.95689 6.46325 1.87496 6.14845 1.875 5.82833V5.625"
        stroke={stroke}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DelIcon: FC<IIcon> = ({ stroke = '#667085' }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.2833 7.50043L11.995 15.0004M8.005 15.0004L7.71667 7.50043M16.0233 4.82543C16.3083 4.86877 16.5917 4.9146 16.875 4.96377M16.0233 4.82543L15.1333 16.3946C15.097 16.8656 14.8842 17.3056 14.5375 17.6265C14.1908 17.9474 13.7358 18.1256 13.2633 18.1254H6.73667C6.26425 18.1256 5.80919 17.9474 5.46248 17.6265C5.11578 17.3056 4.90299 16.8656 4.86667 16.3946L3.97667 4.82543M16.0233 4.82543C15.0616 4.68003 14.0948 4.56968 13.125 4.4946M3.97667 4.82543C3.69167 4.86793 3.40833 4.91377 3.125 4.96293M3.97667 4.82543C4.93844 4.68003 5.9052 4.56968 6.875 4.4946M13.125 4.4946V3.73127C13.125 2.74793 12.3667 1.92793 11.3833 1.8971C10.4613 1.86763 9.53865 1.86763 8.61667 1.8971C7.63333 1.92793 6.875 2.74877 6.875 3.73127V4.4946M13.125 4.4946C11.0448 4.33383 8.95523 4.33383 6.875 4.4946"
        stroke={stroke}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const XIcon: FC<IIcon> = ({ fill = '#667085' }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.27991 5.21985C6.13773 5.08737 5.94969 5.01524 5.75539 5.01867C5.56109 5.0221 5.3757 5.10081 5.23829 5.23822C5.10087 5.37564 5.02216 5.56102 5.01873 5.75532C5.01531 5.94963 5.08743 6.13767 5.21991 6.27985L8.93991 9.99985L5.21991 13.7198C5.14622 13.7885 5.08712 13.8713 5.04613 13.9633C5.00514 14.0553 4.98309 14.1546 4.98132 14.2553C4.97954 14.356 4.99807 14.4561 5.03579 14.5494C5.07351 14.6428 5.12965 14.7277 5.20087 14.7989C5.27209 14.8701 5.35692 14.9262 5.45031 14.964C5.5437 15.0017 5.64373 15.0202 5.74443 15.0184C5.84513 15.0167 5.94445 14.9946 6.03645 14.9536C6.12845 14.9126 6.21125 14.8535 6.27991 14.7798L9.99991 11.0598L13.7199 14.7798C13.7886 14.8535 13.8714 14.9126 13.9634 14.9536C14.0554 14.9946 14.1547 15.0167 14.2554 15.0184C14.3561 15.0202 14.4561 15.0017 14.5495 14.964C14.6429 14.9262 14.7277 14.8701 14.7989 14.7989C14.8702 14.7277 14.9263 14.6428 14.964 14.5494C15.0018 14.4561 15.0203 14.356 15.0185 14.2553C15.0167 14.1546 14.9947 14.0553 14.9537 13.9633C14.9127 13.8713 14.8536 13.7885 14.7799 13.7198L11.0599 9.99985L14.7799 6.27985C14.9124 6.13767 14.9845 5.94963 14.9811 5.75532C14.9777 5.56102 14.8989 5.37564 14.7615 5.23822C14.6241 5.10081 14.4387 5.0221 14.2444 5.01867C14.0501 5.01524 13.8621 5.08737 13.7199 5.21985L9.99991 8.93985L6.27991 5.21985Z"
        fill={fill}
      />
    </svg>
  );
};

export const GlobeIcon: FC<IIcon> = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.6252 2.52544V2.99877C10.6252 3.2771 10.7485 3.54044 10.9627 3.71877L11.8527 4.46044C12.221 4.76794 12.2985 5.3021 12.0327 5.7021L11.6077 6.34044C11.3763 6.68728 11.0358 6.94708 10.6402 7.07877L10.521 7.11877C10.3866 7.16373 10.2643 7.23908 10.1637 7.33896C10.063 7.43885 9.98679 7.56058 9.94085 7.69471C9.8949 7.82885 9.88049 7.97176 9.89873 8.11236C9.91698 8.25297 9.96739 8.38747 10.046 8.50544C10.3535 8.96794 10.1869 9.5946 9.69021 9.84294L7.50021 10.9379L7.85271 11.8204C7.9238 11.9997 7.92747 12.1986 7.86304 12.3804C7.79861 12.5621 7.67046 12.7143 7.50234 12.8087C7.33423 12.9032 7.13757 12.9334 6.94884 12.8939C6.76011 12.8544 6.59212 12.7477 6.47604 12.5938L5.91021 11.8388C5.81431 11.711 5.68735 11.6098 5.54136 11.5449C5.39538 11.4799 5.23522 11.4534 5.07609 11.4678C4.91697 11.4821 4.76415 11.5369 4.63215 11.6269C4.50015 11.7169 4.39334 11.8392 4.32187 11.9821L3.75021 13.1254L3.24021 13.2529M10.6252 2.52544C9.30776 2.41488 7.98449 2.65538 6.78949 3.22098C5.5945 3.78658 4.57025 4.658 3.82054 5.74696C3.07082 6.83592 2.62228 8.10371 2.52037 9.42186C2.41845 10.74 2.66679 12.0617 3.24021 13.2529M10.6252 2.52544C11.9316 2.63439 13.1866 3.08471 14.2652 3.82991C15.3437 4.57511 16.2081 5.58999 16.7722 6.77339C17.3362 7.95678 17.5802 9.26735 17.4799 10.5745C17.3795 11.8815 16.9383 13.1395 16.2002 14.2229L16.0527 13.7821C15.9282 13.4088 15.6893 13.0841 15.37 12.8541C15.0507 12.6241 14.6671 12.5003 14.2735 12.5004H13.7502L13.4802 12.2304C13.3446 12.0946 13.1786 11.9929 12.996 11.9338C12.8133 11.8748 12.6192 11.86 12.4297 11.8907C12.2403 11.9213 12.0608 11.9966 11.9061 12.1103C11.7514 12.224 11.626 12.3729 11.5402 12.5446L11.5102 12.6054C11.4284 12.7693 11.3134 12.9144 11.1725 13.0314C11.0316 13.1485 10.868 13.235 10.6919 13.2854L9.86688 13.5204C9.40854 13.6513 9.12188 14.1054 9.20021 14.5763L9.26104 14.9413C9.32771 15.3363 9.66938 15.6254 10.0694 15.6254C10.7744 15.6254 11.401 16.0771 11.6235 16.7463L11.8027 17.2821M3.24021 13.2529C3.98721 14.8061 5.24635 16.0546 6.80579 16.7884C8.36523 17.5222 10.1298 17.6966 11.8027 17.2821M11.8027 17.2821C13.5943 16.8376 15.1595 15.7489 16.1994 14.2238M13.1252 7.50044C13.1252 8.2471 12.7977 8.9171 12.2785 9.37544"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HomeIcon: FC<IIcon> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M5 12l-2 0l9 -9l9 9l-2 0" />
      <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" />
      <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" />
    </svg>
  );
};

export const NoDataImage: FC<IIcon> = ({ fill = '#667085' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="500"
      height="374"
      fill={fill}
      viewBox="0 0 500 374"
    >
      <path
        fill="#407BFF"
        d="M240.47 72.6c48.1 5.38 69.21-36.32 116.88-30.86 42.54 4.87 71.88 35.18 61.95 76-8.82 36.24-50.81 47.61-65.74 81.56-15.83 36-28.1 74.79-75.9 87.32-93.85 24.6-139.44-90.88-145.83-157.21-2.45-25.46-6.73-86.33 26.51-94.21 33.45-7.94 52.66 34.1 82.13 37.4z"
      ></path>
      <path
        fill="#fff"
        d="M240.47 72.6c48.1 5.38 69.21-36.32 116.88-30.86 42.54 4.87 71.88 35.18 61.95 76-8.82 36.24-50.81 47.61-65.74 81.56-15.83 36-28.1 74.79-75.9 87.32-93.85 24.6-139.44-90.88-145.83-157.21-2.45-25.46-6.73-86.33 26.51-94.21 33.45-7.94 52.66 34.1 82.13 37.4z"
        opacity="0.9"
      ></path>
      <path
        fill="#F5F5F5"
        d="M250 373.06c107.082 0 193.89-5.068 193.89-11.32 0-6.252-86.808-11.32-193.89-11.32-107.082 0-193.89 5.068-193.89 11.32 0 6.252 86.808 11.32 193.89 11.32z"
      ></path>
      <path
        fill="#407BFF"
        d="M104.119 147.859l-.998.072 1.329 18.442.997-.072-1.328-18.442zM106.125 175.822l-.998.072.5 6.942.998-.072-.5-6.942zM337.71 260.66H123.55a9.65 9.65 0 01-9.44-8.81l-10.52-146.13a8.09 8.09 0 012.134-6.212 8.09 8.09 0 016.036-2.588h214.16a9.648 9.648 0 019.44 8.8l10.52 146.13a8.111 8.111 0 01-8.17 8.81z"
      ></path>
      <path
        fill="#407BFF"
        d="M338.53 260.66H124.37a9.65 9.65 0 01-9.44-8.81l-10.52-146.13a8.09 8.09 0 012.134-6.212 8.09 8.09 0 016.036-2.588h214.16a9.648 9.648 0 019.44 8.8l10.52 146.13a8.102 8.102 0 01-8.17 8.81z"
      ></path>
      <path
        fill="#fff"
        d="M338.53 260.66H124.37a9.65 9.65 0 01-9.44-8.81l-10.52-146.13a8.09 8.09 0 012.134-6.212 8.09 8.09 0 016.036-2.588h214.16a9.648 9.648 0 019.44 8.8l10.52 146.13a8.102 8.102 0 01-8.17 8.81z"
        opacity="0.5"
      ></path>
      <path
        fill="#407BFF"
        d="M327.06 101.32H112.18c-5.47.45-4.35 8.78 1.17 8.78h214.52c5.53 0 5.45-8.33-.09-8.78h-.72z"
      ></path>
      <path
        fill="#FAFAFA"
        d="M118.48 105.72a1.839 1.839 0 01-.496 1.417 1.84 1.84 0 01-1.384.583 2.199 2.199 0 01-2.16-2 1.848 1.848 0 011.87-2 2.202 2.202 0 012.17 2zM125.35 105.72a1.839 1.839 0 01-.496 1.417 1.84 1.84 0 01-1.384.583 2.199 2.199 0 01-2.16-2 1.848 1.848 0 011.87-2 2.202 2.202 0 012.17 2zM132.21 105.72a1.848 1.848 0 01-1.87 2 2.186 2.186 0 01-2.16-2 1.844 1.844 0 011.87-2 2.199 2.199 0 012.16 2z"
      ></path>
      <path
        fill="#fff"
        d="M332.85 246.08H128a3.492 3.492 0 01-3.42-3.2l-8.65-120.17a2.906 2.906 0 01.146-1.22 2.908 2.908 0 011.645-1.75 2.929 2.929 0 011.209-.22h204.9a3.48 3.48 0 013.42 3.19l8.66 120.17a2.937 2.937 0 01-3.06 3.2z"
      ></path>
      <path fill="#fff" d="M246.53 200.3l-3.34-46.32-10.1-6.08h-27.81l3.78 52.4h37.47z"></path>
      <path
        fill="#407BFF"
        d="M246.53 200.78h-37.47a.48.48 0 01-.49-.45l-3.77-52.4a.463.463 0 01.13-.36.489.489 0 01.35-.16h27.81a.55.55 0 01.25.07l10.1 6.08a.483.483 0 01.24.38l3.32 46.32a.454.454 0 01-.13.37.471.471 0 01-.34.15zm-37-1H246l-3.28-45.55-9.72-5.85h-27.2l3.73 51.4z"
      ></path>
      <path fill="#EBEBEB" d="M243.19 153.98l-10.1-6.08 3.71 8.06 6.39-1.98z"></path>
      <path
        fill="#407BFF"
        d="M236.8 156.44a.488.488 0 01-.44-.28l-3.71-8.06a.5.5 0 01.11-.57.498.498 0 01.58-.05l10.1 6.08a.502.502 0 01.24.48.489.489 0 01-.34.4l-6.4 2h-.14zm-2.61-7.32l2.87 6.25 5-1.53-7.87-4.72zM221 171.5a2.01 2.01 0 01-.545 1.486 2.012 2.012 0 01-1.455.624 2.306 2.306 0 01-2.26-2.11 1.928 1.928 0 01.52-1.512 1.95 1.95 0 011.48-.608 2.322 2.322 0 012.26 2.12zM234.7 171.5a1.948 1.948 0 01-.524 1.506 1.955 1.955 0 01-1.476.604 2.322 2.322 0 01-2.27-2.11 2.005 2.005 0 01.542-1.492 1.99 1.99 0 011.458-.628 2.308 2.308 0 012.27 2.12zM238.58 185.24a.49.49 0 01-.48-.45c-.25-3.41-5.59-6.18-11.9-6.18-4.19 0-7.95 1.25-9.81 3.25a3.752 3.752 0 00-1.14 2.86.49.49 0 01-.122.364.5.5 0 01-.707.049.5.5 0 01-.171-.343 4.757 4.757 0 011.4-3.59c2-2.19 6.07-3.56 10.52-3.56 6.93 0 12.58 3.11 12.86 7.08a.471.471 0 01-.119.348.486.486 0 01-.331.162v.01zM213.17 167.22a.51.51 0 01-.33-.13.49.49 0 010-.69l2.13-2.29a.489.489 0 01.68 0 .48.48 0 010 .68l-2.13 2.29a.48.48 0 01-.35.14zM237.58 167.22a.551.551 0 01-.33-.13l-2.45-2.29a.478.478 0 01-.108-.532.478.478 0 01.448-.295c.127 0 .249.049.34.137l2.45 2.29a.48.48 0 01-.35.82zM202.26 210.65h2.26l3.26 4.34-.31-4.34h2.28l.56 7.84H208l-3.24-4.31.31 4.31h-2.28l-.53-7.84zM211.33 214.57a3.806 3.806 0 01.86-3 3.764 3.764 0 012.9-1.07 4.38 4.38 0 013.09 1.05 4.32 4.32 0 011.27 2.94 4.76 4.76 0 01-.3 2.25 3.001 3.001 0 01-1.24 1.37 4.164 4.164 0 01-2.14.49 5.253 5.253 0 01-2.23-.42 3.618 3.618 0 01-1.5-1.34 4.66 4.66 0 01-.71-2.27zm2.43 0a2.73 2.73 0 00.56 1.7 1.593 1.593 0 001.24.52 1.386 1.386 0 001.17-.51 2.752 2.752 0 00.27-1.78 2.569 2.569 0 00-.56-1.62 1.642 1.642 0 00-1.25-.51 1.387 1.387 0 00-1.14.52 2.531 2.531 0 00-.29 1.7v-.02zM224.15 210.65h3.6a4.512 4.512 0 011.74.29c.439.184.83.468 1.14.83.315.367.556.792.71 1.25a6.3 6.3 0 01.3 1.52 5.071 5.071 0 01-.15 1.95 2.805 2.805 0 01-.71 1.16c-.274.29-.619.504-1 .62a5.586 5.586 0 01-1.43.22h-3.59l-.61-7.84zm2.55 1.78l.31 4.28h.59c.365.024.73-.034 1.07-.17a.999.999 0 00.46-.59c.114-.444.142-.906.08-1.36a2.723 2.723 0 00-.53-1.7 1.807 1.807 0 00-1.38-.46h-.6zM237.45 217.19h-2.75l-.29 1.3h-2.47l2.38-7.84H237l3.51 7.84h-2.54l-.52-1.3zm-.63-1.69l-1.06-2.82-.66 2.82h1.72zM239.37 210.65h7.36l.14 1.94h-2.47l.42 5.9h-2.42l-.42-5.9h-2.47l-.14-1.94zM252.37 217.19h-2.75l-.29 1.3h-2.47l2.38-7.84h2.64l3.5 7.84h-2.53l-.48-1.3zm-.63-1.69l-1.07-2.82-.67 2.82h1.74z"
      ></path>
    </svg>
  );
};

export const NoImage: FC<IIcon> = ({ stroke = '#667085' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M15 8h.01" />
      <path d="M3 6a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12z" />
      <path d="M3 16l5 -5c.928 -.893 2.072 -.893 3 0l5 5" />
      <path d="M14 14l1 -1c.928 -.893 2.072 -.893 3 0l3 3" />
    </svg>
  );
};

export const PagesIcon: FC<Partial<{ stroke: string }>> = ({ stroke = '#98A2B3' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke={stroke}
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" />
    <path d="M13.5 6.5l4 4" />
    <path d="M16 19h6" />
  </svg>
);
